const access = {
  // HeroSection
  'access.hero.homeLink': 'ホーム',
  'access.hero.aboutLink': 'アカデミーについて',
  'access.hero.currentPage': 'アクセス',
  'access.hero.title': 'アクセス',
  'access.hero.titleEn': 'ACCESS',
  'access.hero.lead': '本校は東京・お台場（江東区青海）にあります。東京・お台場の執事学校へのご来訪は完全予約制です。',
  'access.hero.imgAlt': '青海の本校が入るビルの入口に立つ執事',

  // LocationTable
  'access.location.label': 'LOCATION',
  'access.location.title': '校舎への行き方は？',
  'access.location.titleEn': 'Find Us in Odaiba, Tokyo',
  'access.location.lead': '本校は東京・お台場、江東区青海にあります。ゆりかもめの二つの駅からそれぞれ徒歩約5分の便利な立地です。日本の執事学校として通学しやすい施設環境を整えています。',
  'access.location.tableHeader': '所在地情報',
  'access.location.0.label': '名称',
  'access.location.0.value': '日本執事アカデミー（運営: 一般社団法人全日本執事協会）',
  'access.location.1.label': '住所',
  'access.location.1.value': '〒135-0064 東京都江東区青海2丁目7-4',
  'access.location.2.label': '電話',
  'access.location.2.value': '03-6824-4086',
  'access.location.2.note': '受付 平日10:00〜17:00',
  'access.location.3.label': 'メール',
  'access.location.3.value': 'info@butler-academy.jp',
  'access.location.4.label': '来訪',
  'access.location.4.value': '完全予約制',

  // TrainAccess
  'access.train.label': 'BY TRAIN',
  'access.train.title': '電車でのアクセス',
  'access.train.titleEn': 'Via Yurikamome Line',
  'access.train.lead': '最も便利なのは、ゆりかもめのご利用です。「東京国際クルーズターミナル駅」「テレコムセンター駅」のいずれからも、徒歩約5分でお越しいただけます。',
  'access.train.note': '※新橋駅からゆりかもめで約15分、豊洲駅から約10分です。お台場エリアは商業施設や臨海公園が近く、来訪前後にも立ち寄りやすい環境です。',
  'access.train.0.name': '東京国際クルーズターミナル駅',
  'access.train.0.line': 'ゆりかもめ',
  'access.train.0.time': '徒歩約5分',
  'access.train.0.directions': '駅を出て青海方面へ直進、信号を渡り二つ目の角を右折してください。ガラス張りの建物が見えてまいります。',
  'access.train.1.name': 'テレコムセンター駅',
  'access.train.1.line': 'ゆりかもめ',
  'access.train.1.time': '徒歩約5分',
  'access.train.1.directions': '駅西口を出て左方向へ進み、大きな交差点を渡ってから青海遊歩道沿いにお進みください。約400m先の左手に校舎がございます。',

  // MapSection (map section may have hardcoded text)
  'access.map.label': 'MAP',
  'access.map.title': '地図で確認する',
  'access.map.titleEn': 'Campus Location',
  'access.map.address': '東京都江東区青海2丁目7-4',
  'access.map.googleMaps': 'Google マップで開く',

  // VisitGuide
  'access.visit.label': 'VISIT',
  'access.visit.title': 'ご来訪にあたって',
  'access.visit.titleEn': 'Visiting the Campus',
  'access.visit.lead': 'ご来訪はすべて完全予約制とさせていただいています。見学・個別相談・体験講座のいずれも、事前のご予約をお願いいたします。',
  'access.visit.0.title': '完全予約制について',
  'access.visit.0.text': '校舎は授業や実技演習を行う教育施設のため、予告なくのご来訪はご遠慮いただいております。見学をご希望の方は、お電話（03-6824-4086・平日10:00〜17:00）・メール（info@butler-academy.jp）・お問い合わせフォームのいずれかで事前にご予約ください。',
  'access.visit.1.title': '見学について',
  'access.visit.1.text': '所要時間は30分程度を目安としています。授業日（土日）以外の平日にも対応しております。校舎の雰囲気を実際にご覧いただき、学びのイメージを具体化していただければ幸いです。',
  'access.visit.2.title': '各種お申し込み',
  'access.visit.2.text': '見学のほか、個別相談、体験講座のお申し込みも承っています。いずれも完全予約制ですので、まずはお気軽にお問い合わせください。',
  'access.visit.2.link0': '個別相談を予約する',
  'access.visit.2.link1': '体験講座を見る',
  'access.visit.2.link2': 'お問い合わせ',

  // FAQSection
  'access.faq.label': 'FAQ',
  'access.faq.title': 'よくあるご質問',
  'access.faq.titleEn': 'Frequently Asked Questions',
  'access.faq.footer': 'その他のご質問はフォームよりお寄せください',
  'access.faq.0.question': '最寄り駅はどこですか？',
  'access.faq.0.answer': 'ゆりかもめ「東京国際クルーズターミナル駅」と「テレコムセンター駅」で、いずれも徒歩約5分です。',
  'access.faq.1.question': '予約なしで訪問できますか？',
  'access.faq.1.answer': 'ご来訪は完全予約制です。お問い合わせフォーム・お電話（平日10:00〜17:00）・メールのいずれかで事前にご予約ください。',
  'access.faq.2.question': '駐車場はありますか？',
  'access.faq.2.answer': '公共交通機関でのご来校をお勧めしています。お車でお越しの場合は事前にご相談ください。',

  // MapSection
  'access.map.note': '※完全予約制のため、ご来訪前に必ずご予約ください',

  // CTASection
  'access.cta.label': 'NEXT STEP',
  'access.cta.title': 'まずはお気軽にお問い合わせください',
  'access.cta.body': 'ご来訪はすべて完全予約制です。個別相談や体験講座のお申し込みも、こちらから承っています。',
  'access.cta.note': '※ご相談はオンラインでも承ります',
  'access.cta.consultation': '個別相談を予約する',
  'access.cta.seminar': '体験講座を見る',
  'access.cta.contact': 'お問い合わせ',

  // RelatedPages
  'access.related.label': 'LEARN MORE',
  'access.related.title': '関連ページ',
  'access.related.titleEn': 'Explore Further',
  'access.related.viewLink': '詳しく見る',
  'access.related.0.title': '施設・設備紹介',
  'access.related.0.desc': 'お台場の本校と実習環境',
  'access.related.1.title': '個別相談予約',
  'access.related.1.desc': 'オンライン可・無料の個別相談',
  'access.related.2.title': '体験講座',
  'access.related.2.desc': '1日で執事の所作を体験',
  'access.related.3.title': 'お問い合わせ',
  'access.related.3.desc': 'ご質問・ご相談の窓口',

  // Last updated
  'access.lastUpdated': '最終更新: 2026年7月8日',
};

export default access;
